import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import TeamJoinForm from '../components/TeamJoinForm';

const JoinTeam = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [teamCode, setTeamCode] = useState('');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('player');

  useEffect(() => {
    // Extract parameters from URL
    const code = searchParams.get('code');
    const emailParam = searchParams.get('email');
    const roleParam = searchParams.get('role');

    if (code) setTeamCode(code);
    if (emailParam) setEmail(emailParam);
    if (roleParam) setRole(roleParam);
  }, [searchParams]);

  // If user is not authenticated, redirect to login
  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div className="text-center">
            <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
              Please log in to join the team
            </h2>
            <p className="mt-2 text-sm text-gray-600">
              You need to be logged in to join a team.
            </p>
            <button
              onClick={() => navigate('/login')}
              className="mt-4 w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Go to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Join Team
          </h1>
          <p className="text-gray-600">
            {teamCode ? `You've been invited to join a team!` : 'Enter a team code to join a team.'}
          </p>
        </div>

        <div className="max-w-md mx-auto">
          <TeamJoinForm 
            initialTeamCode={teamCode}
            initialEmail={email}
            initialRole={role}
            onSuccess={() => {
              // Redirect to team management after successful join
              navigate('/team-management');
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default JoinTeam;
